import React from 'react';
import { Search, Users, Globe, ExternalLink, MoreVertical, ShieldCheck } from 'lucide-react';
const customers = [{
  id: 1,
  name: 'Global Tech Solutions',
  site: 'globaltech.io',
  plan: '$99 Tier',
  status: 'Active',
  region: 'North America'
}, {
  id: 2,
  name: 'Abuja Creative Hub',
  site: 'abujacreative.ng',
  plan: '$65 Tier',
  status: 'Active',
  region: 'Nigeria'
}, {
  id: 3,
  name: 'Lagos FinTech',
  site: 'lagosfin.tech',
  plan: '$99 Tier',
  status: 'Active',
  region: 'Nigeria'
}, {
  id: 4,
  name: 'Safari Tours Ltd',
  site: 'safari.co.ke',
  plan: '$35 Tier',
  status: 'Pending',
  region: 'Kenya'
}];
export function Customers() {
  return <div className="space-y-6 max-w-[1600px] mx-auto" data-id="element-2756">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-2757">
        <div data-id="element-2758">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-2759">Customer CRM</h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-2760">
            Manage client sites, white-label dashboards, and security status.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-2761">
          <div className="relative" data-id="element-2762">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} data-id="element-2763" />
            <input type="text" placeholder="Search customers..." className="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20" data-id="element-2764" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-2765">
        <table className="w-full text-left border-collapse" data-id="element-2766">
          <thead data-id="element-2767">
            <tr className="text-[10px] font-bold uppercase tracking-wider text-gray-400 border-b border-gray-100 bg-gray-50/50" data-id="element-2768">
              <th className="px-6 py-4" data-id="element-2769">Customer & Site</th>
              <th className="px-6 py-4" data-id="element-2770">Hosting Plan</th>
              <th className="px-6 py-4" data-id="element-2771">Region</th>
              <th className="px-6 py-4" data-id="element-2772">Security</th>
              <th className="px-6 py-4" data-id="element-2773">Status</th>
              <th className="px-6 py-4" data-id="element-2774"></th>
            </tr>
          </thead>
          <tbody className="text-sm" data-id="element-2775">
            {customers.map(c => <tr key={c.id} className="hover:bg-gray-50 transition-colors border-b border-gray-50 last:border-0" data-id="element-2776">
                <td className="px-6 py-4" data-id="element-2777">
                  <div className="flex items-center gap-3" data-id="element-2778">
                    <div className="w-8 h-8 rounded bg-indigo-50 text-indigo-600 flex items-center justify-center font-bold text-xs" data-id="element-2779">
                      {c.name.charAt(0)}
                    </div>
                    <div data-id="element-2780">
                      <p className="font-bold text-slate-900" data-id="element-2781">{c.name}</p>
                      <p className="text-[10px] text-gray-400 font-bold flex items-center gap-1" data-id="element-2782">
                        <Globe size={10} data-id="element-2783" /> {c.site}
                      </p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 font-medium text-slate-600" data-id="element-2784">
                  {c.plan}
                </td>
                <td className="px-6 py-4 text-gray-500" data-id="element-2785">{c.region}</td>
                <td className="px-6 py-4" data-id="element-2786">
                  <div className="flex items-center gap-1 text-emerald-600 font-bold text-[10px] uppercase" data-id="element-2787">
                    <ShieldCheck size={14} data-id="element-2788" /> SSL Active
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-2789">
                  <span className={`px-2 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${c.status === 'Active' ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'}`} data-id="element-2790">
                    {c.status}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-2791">
                  <div className="flex items-center gap-2" data-id="element-2792">
                    <button className="p-2 text-gray-400 hover:text-indigo-600 transition-colors" title="Login as Customer" data-id="element-2793">
                      <ExternalLink size={16} data-id="element-2794" />
                    </button>
                    <button className="p-2 text-gray-400 hover:text-slate-600 transition-colors" data-id="element-2795">
                      <MoreVertical size={16} data-id="element-2796" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}